import EbateAxios from "queries/ebateAxios"
import { ValidationResultModel } from "components/models"
import { AxiosResponse } from "axios"
import { UsersGridRequest } from "components/pages/maintanance/users/userList/userList.models"
import { SubTenantUsersGridDataResponse } from "components/pages/maintanance/subTenantUserManagement/SubTenantUserManagementList/SubTenantUserManagementList.models"
import {
  UserEmailResendRequestModel,
  UserFullInfoModel,
} from "components/pages/maintanance/users/userswizard/user.models"
import {
  CreateSubTenantUserRequest,
  SubTenantUserEmailResendRequestModel,
  UpdateSubTenantUserRequest,
} from "components/pages/maintanance/subTenantUserManagement/SubTenantUserManagementWizard/subTenantUser.model"

const subTenantUserUrl = "/api/SubTenantUser"

export const deleteSubTenantUser = async (
  userId: string
): Promise<AxiosResponse<ValidationResultModel>> => {
  const url = `${subTenantUserUrl}/DeleteSubTenantUser/${userId}`
  const { AxiosDelete } = EbateAxios()

  return AxiosDelete<ValidationResultModel>(url)
}

export const getSubTenantUsersGridData = async (
  request: UsersGridRequest,
  companyId: number | undefined,
  abortSignal?: AbortSignal
) => {
  let url = `${subTenantUserUrl}/GetSubTenantUsersGridData`

  if (companyId) {
    url += `/${companyId}`
  }
  const { AxiosPost } = EbateAxios()

  return AxiosPost<UsersGridRequest, SubTenantUsersGridDataResponse>(
    url,
    request,
    abortSignal
  )
}

export const getSubTenantUserById = async (userId: string) => {
  const url = `${subTenantUserUrl}/GetSubTenantUserById/${userId}`
  const { AxiosGet } = EbateAxios()

  return AxiosGet<UserFullInfoModel>(url)
}

export const createSubTenantUser = async (
  request: CreateSubTenantUserRequest
) => {
  const url = `${subTenantUserUrl}/CreateSubTenantUserAsync`

  const { AxiosPost } = EbateAxios()

  return AxiosPost<CreateSubTenantUserRequest, ValidationResultModel>(
    url,
    request
  )
}

export const updateSubTenantUser = async (
  request: UpdateSubTenantUserRequest
) => {
  const url = `${subTenantUserUrl}/UpdateSubTenantUser`

  const { AxiosPut } = EbateAxios()

  return AxiosPut<UpdateSubTenantUserRequest, any>(url, request)
}

export const resendSubTenantEmail = async (
  request: UserEmailResendRequestModel | SubTenantUserEmailResendRequestModel
) => {
  const url = `${subTenantUserUrl}/ResendPortalEmail`

  const { AxiosPost } = EbateAxios()

  return AxiosPost<
    UserEmailResendRequestModel | SubTenantUserEmailResendRequestModel,
    ValidationResultModel
  >(url, request)
}
